import {Box} from '@mui/material';
import React from 'react';

const NoPage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 80px)',
      }}
    >
      <p
        style={{
          fontSize: '2rem',
          fontWeight: 'bold',
          color: 'rgba(43, 51, 125, 1)',
          marginBottom: '20px',
        }}
      >
        Page Not
      </p>
      <p
        style={{
          fontSize: '1.5rem',
          fontWeight: 'bold',
          marginBottom: '20px',
          color: 'rgba(43, 51, 125, 1)',
        }}
      >
        Found
      </p>
    </Box>
  );
};

export default NoPage;
